import { render, staticRenderFns } from "./PrivacyConsent.vue?vue&type=template&id=6116ce46&scoped=true&"
import script from "./PrivacyConsent.vue?vue&type=script&lang=ts&"
export * from "./PrivacyConsent.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyConsent.vue?vue&type=style&index=0&id=6116ce46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6116ce46",
  null
  
)

export default component.exports